import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import '../Style/Contact.css'

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceID = 'service_2920';
    const templateID = 'template_2920';
    const userID = 'AhPNndtB1F8-nRS0c';

    emailjs.send(serviceID, templateID, formData, userID)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setStatus('Message sent successfully!');
        setFormData({ name: '', email: '', message: '' });

        // Hide the toast after 3 seconds
        setTimeout(() => {
          setStatus('');
        }, 3000);
      }, (err) => {
        console.error('FAILED...', err);
        setStatus('Failed to send message');
        setTimeout(() => {
          setStatus('');
        }, 3000);
      });
  };

  return (
    <div className="container my-5 p-5 shadow form position-relative" style={{ maxWidth: '600px' }}>
      <h2 className="mb-4 fw-bold">Contact Us</h2>

      {/* Toast Message */}
      {status && (
        <div className="toast-notification position-absolute top-0 start-50 translate-middle-x mt-2">
          <div className="alert alert-success shadow-sm mb-0 px-4 py-2" role="alert">
            {status}
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input
            type="text"
            name="name"
            className="form-control"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Message</label>
          <textarea
            name="message"
            className="form-control"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <button type="submit" className="btn btn-custom col-3 fw-bold"><span>Send</span></button>
      </form>
    </div>
  );
}

export default ContactForm;
